
import { motion } from 'framer-motion';

const FortuneHeader = () => {
  return (
    <>
      <motion.h1 
        className="text-3xl font-light mb-2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        Daily Fortune
      </motion.h1>
      
      <motion.p 
        className="text-muted-foreground mb-12"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        Discover what fate has in store for you today
      </motion.p>
    </>
  );
};

export default FortuneHeader;
